import { render, staticRenderFns } from "./leaderList.vue?vue&type=template&id=322acfec&scoped=true"
import script from "./leaderList.vue?vue&type=script&lang=js"
export * from "./leaderList.vue?vue&type=script&lang=js"
import style0 from "./leaderList.vue?vue&type=style&index=0&id=322acfec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322acfec",
  null
  
)

export default component.exports